
import { Subject } from 'rxjs';
import { Validators } from '@angular/forms';
import { Injectable } from '@angular/core';
import { Utils } from '../../../../shared/utils/utils';
import { Title } from '../../../../shared/title/title.component';
import { AutocompleteService } from '../../../../shared/autocomplete/autocomplete.service';
import { PersonaService } from '../../../../core/http/apiPersona/persona.service';
import { CustomValidators } from '../../../../shared/validators/custom-validators';
import { DynamicFormConfig } from '../../../../shared/dynamic-form/dynamic-form-config.interface';
import moment from 'moment';

@Injectable()
export class JsonConfiguration {
  AddressChanges = new Subject<string>();
  AddressFound = new Subject<any>();
  selectAddress: any = [];

  constructor(
    private personaService: PersonaService,
    private autocompleteService: AutocompleteService
  ) {
    this.ShowAddressSuggestions();
  }

  titleData: Title = {
    title: 'Domicilio habitual',
    subtitle: '',
  };

  titleDataDesktop: Title = {
    title: 'Datos de contacto',
    subtitle: ''
  }

  titleDataXsell: Title = {
    title: 'Datos personales',
    subtitle: '',
  };

  /**
   * Look for address autocomplete suggestions and notify the form to fill the fields
   */
  ShowAddressSuggestions() {
    const minimumLetters = 4;

    this.AddressChanges.subscribe(
      (changes: any) => {
        if (changes.length >= minimumLetters) {
          this.personaService.getAddressAutocompleteData(changes).subscribe(
            (AddressData: any) => {
              this.selectAddress.options = [];

              AddressData.data.predictions.forEach((element: any) => {
                this.selectAddress.options.push({
                  code: element.place_id,
                  name: Utils.cleanAccents(element.description),
                });
              });

              if (AddressData.data.predictions.length > 0) {
                let selectedAddress = this.selectAddress.options.find(
                  (element: any) => {
                    return (
                      Utils.cleanAccents(element.name) ===
                      Utils.cleanAccents(changes)
                    );
                  }
                );

                if (selectedAddress) {
                  this.getAddressDetails(selectedAddress.code);
                }
              }
            },
            (err: any) => {
              console.log(err);
            }
          );
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  getAddressDetails(place_id: Number) {
    this.personaService
      .getAddressAutocompleteDataDetail(place_id)
      .subscribe((addressDetailData: any) => {
        if (addressDetailData.data.result.address_components.length > 0) {
          this.AddressFound.next(addressDetailData);
        }
      });
  }

  dynamicXsellFormContact: DynamicFormConfig = {
    fields: [
      {
        type: 'input',
        inputType: 'text',
        spanLabel: 'DNI',
        placeHolder: 'DNI',
        disabled: false,
        maxTextLength: 9,
        matFormFieldWidth: '100%',
        name: 'dni',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo requerido',
          },
          {
            name: 'pattern',
            validator: Validators.pattern(/^\d{8}[A-Za-z]$/),
            message: 'Formato inválido. Debe tener 8 números seguidos de una letra',
          }
        ]
      },
      {
        type: 'input',
        inputType: 'text',
        spanLabel: 'Nombre',
        placeHolder: 'Nombre',
        disabled: false, // No editable
        maxTextLength: 50,
        matFormFieldWidth: '100%',
        name: 'nombre',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo requerido',
          },
        ],
      },
      {
        type: 'input',
        inputType: 'text',
        spanLabel: 'Apellidos',
        placeHolder: 'Apellidos',
        disabled: false, // No editable
        maxTextLength: 50,
        matFormFieldWidth: '100%',
        name: 'apellidos',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo requerido',
          },
        ],
      },
      {
        type: 'date',
        spanLabel: 'Fecha de Nacimiento',
        placeHolder: 'Fecha de nacimiento',
        disabled: false, // Editable
        matFormFieldWidth: '100%',
        name: 'fechaNacimiento',
        dateConfig: {
          minDate: moment().subtract(100, 'years').toDate(),
          maxDate: moment().toDate(),
          yearAndMonth: false
        },

        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo requerido',
          },
          {
            name: 'minimumAge',
            validator: CustomValidators.minimumAge(18),
            message: 'Debe ser mayor de edad',
          },
        ],
      },
      {
        type: 'input',
        inputType: 'text',
        spanLabel: 'Email',
        placeHolder: '',
        disabled: false, // No editable
        maxTextLength: 50,
        matFormFieldWidth: '100%',
        name: 'Email',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo requerido',
          },
        ],
      },
      {
        type: 'input',
        inputType: 'text',
        spanLabel: 'Telefono',
        placeHolder: '',
        disabled: false, // No editable
        maxTextLength: 50,
        matFormFieldWidth: '100%',
        name: 'Telefono',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo requerido',
          },
        ],
      },
            {
        type: 'input',
        spanLabel: 'Direccion',
        placeHolder: '',
        disabled: false, // Editable
        maxTextLength: 50,
        matFormFieldWidth: '100%',
        name: 'direccion',
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message: 'Campo requerido',
          },
          {
            name: 'pattern',
            validator: Validators.pattern(/^.+\s\d+,\s.+,\s\d{5}$/),
            message: 'Formato inválido. Usa: Calle Número, Provincia, CP',
          }
        ],
        select: { options: this.selectAddress },
      }
    ],
  };

}
